import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';
import { DealerCode, DealerFilterCriteria, ExportCPFData } from './types/type';


class CPFProvider extends BaseApi {
	getDealer(params: DealerFilterCriteria) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetDealer`, params);
	}

	getDealerCPF(params: DealerCode) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetDealerCPF`, params);
	}

	assignCPF(dto: ExportCPFData) {
		return this.post(`/${DMS_MODULE}/${NAME}/ExportCPF`, dto);
	}
}
export const apiProvider = new CPFProvider(DMS_MODULE, NAME);
